import React, { useState } from 'react'
import { saveAs } from 'file-saver'
import { imageAddress } from '../../utils/useful'
import { canViewProcessStage } from '../../utils/processStageAccess'

const documents = [
    { key: 'vetLetter', label: 'نامه دامپزشک' },
    { key: 'pregnancyReport', label: 'گزارش تلقیح مادیان' },
]

export default function GeneratedStageDocuments({ stage, record, userType }) {
    const [loading, setLoading] = useState(null)
    const [error, setError] = useState(false)
    if (!canViewProcessStage(stage, userType)) return null
    const enabled = documents.filter(document => stage?.[document.key] === true)
    if (!enabled.length) return null

    async function download(file, key) {
        setLoading(key)
        setError(false)
        try {
            const response = await fetch(imageAddress(file))
            if (!response.ok) throw new Error('Download failed')
            const blob = await response.blob()
            if (!(await blob.slice(0, 5).text()).startsWith('%PDF-')) throw new Error('Invalid PDF')
            saveAs(blob, file.originalName || `${key}.pdf`)
        } catch (_) {
            setError(true)
        } finally {
            setLoading(null)
        }
    }

    return (
        <section aria-label="فایل‌های خودکار مرحله" style={{ padding: 16, marginBottom: 20, background: '#f1f8f6', border: '1px solid #c9ddda', borderRadius: 12 }}>
            {enabled.map(({ key, label }) => {
                const value = record?.values?.[key]
                const file = Array.isArray(value) ? value[0] : value
                return (
                    <div key={key} style={{ padding: '8px 0', display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center', justifyContent: 'space-between' }}>
                        <strong>{label}</strong>
                        {file?.address ? (
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                <a href={imageAddress(file)} target="_blank" rel="noopener noreferrer">مشاهده PDF</a>
                                <button type="button" disabled={loading !== null} onClick={() => download(file, key)} style={{ border: 0, borderRadius: 20, background: '#10453d', color: '#fff', padding: '8px 18px', cursor: 'pointer' }}>
                                    {loading === key ? 'در حال دریافت…' : 'دانلود PDF'}
                                </button>
                            </div>
                        ) : <span style={{ color: '#536c67', fontSize: 13 }}>پس از ثبت این مرحله، فایل به‌صورت خودکار ساخته می‌شود.</span>}
                    </div>
                )
            })}
            {error && <p role="alert">دانلود انجام نشد. از «مشاهده PDF» فایل را باز و دانلود کنید.</p>}
        </section>
    )
}
